import React, {PureComponent} from 'react';
import Util from '../../util/AspectRatioCardUtil';
import {loadTruncationLib} from '../../util/loadTruncationLib';
import PropTypes from 'prop-types';
import './AspectRatioCardText.less';

class AspectRatioCardText extends PureComponent {
    static propTypes = {
        /** The text to display. Text will be truncated as necessary. */
        text: PropTypes.string.isRequired
    };

    static defaultProps = {
        text: ''
    };

    state = {
        textContainer: <div className="AspectRatioCardText--truncated small">{this.props.text}</div>
    }

    componentDidMount() {
        if (!Util.supportsNativeClamp()) {
            loadTruncationLib().then((ShiitakeModule) => {
                const Shiitake = ShiitakeModule.default;
                this.setState({
                    textContainer: (
                        <Shiitake lines={2} throttleRate={200} className="small" tagName="span">
                            {this.props.text}
                        </Shiitake>
                    )
                });
            });
        }
    }

    render() {
        const {textContainer} = this.state;

        return (
            textContainer
        );
    }
}


export default AspectRatioCardText;
